import React from "react";
import { useSelector, useDispatch } from "react-redux";
import * as Icons from "Components/Icons";
import { SigningForm } from "./SigningForm";
import { Modal, ModalBody } from "Components/ReactstrapSlim";

const DEFAULT_IMAGE_MESSAGE = ["Work from where it works", "for you."];

export interface SigningModalProps {
}

type SigningModeOrUndefined = LSStore.SigningMode | undefined;

export const SigningModal: React.FC<SigningModalProps> = () => {
   const isOpen = useSelector(state => state.signingModal.isOpen);
   const initialMode = useSelector(state => state.signingModal.initialMode) as SigningModeOrUndefined;
   const [firstLineMessage, secondLineMessage] = useSelector(state => state.signingModal.imageMessage ?? DEFAULT_IMAGE_MESSAGE);
   const dispatch = useDispatch();
   const toggle = () => {
      dispatch(LSStore.signingModalSlice.actions.toggle());
      if (LSHelper.Account.onCloseCallback && typeof LSHelper.Account.onCloseCallback === "function")
         LSHelper.Account.onCloseCallback();
   }

   return (
      <>
         {isOpen && <Modal className="signing-modal" isOpen={isOpen} toggle={toggle} centered trapFocus>
            <ModalBody className="signing-modal-body" aria-modal>
               <div className="signing-modal-body-inner">
                  <div role="button" tabIndex={0} className="signing-modal-btn-close" aria-label="close" onClick={toggle}>
                     <Icons.Close />
                  </div>
                  <div className="signing-modal-left">
                     <SigningForm className="signing-page-form" mode={initialMode} isModal={true} closeModal={toggle} />
                     <div className="signing-modal-footer">
                        © LiquidSpace, Inc. {new Date().getFullYear()}
                     </div>
                  </div>
                  <div className="signing-modal-right">
                     <div className="signing-modal-moto">
                        <div className="signing-modal-moto-line"></div>
                        {firstLineMessage && <div className="signing-modal-moto-row">
                           {firstLineMessage}
                        </div>}
                        {secondLineMessage && <div className="signing-modal-moto-row">
                           <span className="signing-modal-moto-highlight">
                              {secondLineMessage}
                           </span>
                        </div>}
                     </div>
                  </div>
               </div>
            </ModalBody>
         </Modal>}
      </>
   )
}